import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../modal/Modal";
import { Button, Checkbox, Textarea } from "@mantine/core";
import { ImageFile, PositionImage } from "../../../interfaces";
import { PaperClipOutlined } from "@ant-design/icons";
import UploadAttachment from "../../account/UploadAttachment";
import { toast } from "react-toastify";

type TModalProps = {
  current?: PositionImage | null;
  setModalVisible: (value: boolean) => void;
  modalVisible: boolean;
  title?: string;
  successButtonName?: string;
  dangerButtonName?: string;
  onSuccess?: (
    rejectedDescription: string,
    rejectedReason: string,
    files: ImageFile[]
  ) => void;
  onDanger?: () => void;
  contentStyle?: string;
};

const DeclineAllModal: React.FC<TModalProps> = ({
  setModalVisible,
  modalVisible,
  title,
  successButtonName,
  onSuccess = () => {},
  dangerButtonName,
  onDanger,
  contentStyle,
}) => {
  const { t } = useTranslation();
  //const [approved, setApproved] = React.useState<boolean>(false);
  const [files, setFiles] = React.useState<ImageFile[]>([]);

  const onModalClose = () => {
    setModalVisible(false);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    const ResolutionLow = e.target["ResolutionLow"].checked;
    const WrongColor = e.target["WrongColor"].checked;
    const Other = e.target["Other"].checked;

    const rejectedReason = [
      ResolutionLow && "ResolutionLow",
      WrongColor && "WrongColor",
      Other && "Other",
    ]
      .filter((reason) => !!reason)
      .join(" ")
      .trim();

    if (rejectedReason === "") {
      toast.warn("Please check at least 1 reason");
      return;
    }

    const rejectedDescription = e.target["description"].value;
    onSuccess(rejectedDescription, rejectedReason, files);
  };

  return (
    <>
      <Modal compact center visible={modalVisible} onClose={onModalClose}>
        <form onSubmit={handleSubmit}>
          <div
            className={`text-center  ${contentStyle ? contentStyle : "mb-20"}`}
          >
            {title && <h2 className="f-w-700">{t(title)}</h2>}
          </div>
          <div className="approve-form-row">
            <Checkbox name="ResolutionLow" label={t("resolutionTooLow")} />
          </div>
          <div className="approve-form-row">
            <Checkbox name="WrongColor" label={t("colorsAreWrong")} />
          </div>
          <div className="approve-form-row">
            <Checkbox name="Other" label={t("other")} />
          </div>

          <Textarea
            name="description"
            placeholder={t("typeInHere")}
            minRows={4}
          ></Textarea>

          <UploadAttachment files={files} setFiles={setFiles}>
            <p className="image-files__title">
              {t("attachFile")} <PaperClipOutlined />
            </p>
          </UploadAttachment>
          <div className="send-printdata mt-30 w-auto">
            {/* <Checkbox
              checked={approved}
              onChange={(e: any) => setApproved(e.target.checked)}
              label={t("approveCorrectText")}
            /> */}
            <div className="row gap-30 row-column-phone-responsive">
              <Button
                color={"red"}
                //disabled={!approved}
                mt={10}
                size="lg"
                fullWidth
                type="submit"
              >
                {t(successButtonName || "confirm")}
              </Button>
              {onDanger && (
                <Button
                  className={"modal-outlined-button"}
                  color={"blue"}
                  variant={"outline"}
                  mt={10}
                  size="lg"
                  fullWidth
                  onClick={onDanger}
                >
                  {t(dangerButtonName || "cancel")}
                </Button>
              )}
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default DeclineAllModal;
